import {Api} from "./Api";
import {ReqBookingData, ResBookingData} from "./structs/BookingData";
import {ReqPriceData, ResPriceData} from "./structs/PriceData";
import {Zp} from "./Zp";
import {PreisRechner} from "./PreisRechner";
import {getUrlParamInt, setUrlParam} from "./tools/urlParam";
import {Detail} from "./Detail";

export class BookingRequest {
    static request(priceData: ResPriceData, callback: (response: ResBookingData) => void): void {
        if (!priceData || !priceData.price || !<string>$("#Email").val()) {
            if (callback) callback(null);
            return;
        }
        const data: ReqBookingData = {
            priceData: priceData,
            NrAdultsTravelling: parseInt(<string>$("#NrAdultsTravelling").val()),
            NrChildrenTravelling: parseInt(<string>$("#NrChildrenTravelling").val()),
            Title: <string>$('input[name="Title"]:checked').val() ?? "",
            FirstName: <string>$("#FirstName").val(),
            LastName: <string>$("#LastName").val(),
            StreetAndNr: <string>$("#StreetAndNr").val(),
            AddressExtra: <string>$("#AddressExtra").val(),
            ZipCode: <string>$("#ZipCode").val(),
            City: <string>$("#City").val(),
            Country: <string>$("#Country").val(),
            Email: <string>$("#Email").val(),
            Telephone: <string>$("#Telephone").val(),
            PaymentType: <string>$('input[name="PaymentType"]:checked').val() ?? "",
            TermsConditions: $('#TermsConditions').is(':checked'),
        };
        Api.bookingRequest(data, r => {
            console.log(r);
            if (callback) callback(r);
        });
    }

    static book() {
        BookingRequest._submitButtonActive(false);
        BookingRequest.request(BookingRequest.priceResult, (r: ResBookingData) => {
            if (r == null) {
                BookingRequest._submitButtonActive(true);
                return;
            }
            $("#step_cir1").attr("class", "stepCircleOut");
            $("#step_cir2").attr("class", "stepCircleOutActive");
            $("#step_txt1").addClass("text-muted");
            $("#step_txt2").removeClass("text-muted");
            $("#step_txt1 span").removeClass("active");
            $("#step_txt2 span").addClass("active");
            $("#bookingform").html(r.confirmationHtml);
        });
    }

    static init() {
        const adults = $("#NrAdultsTravelling");
        adults.val(getUrlParamInt("pax", 1));

        adults.on("change", function () {
            setUrlParam("pax", $(this).val() + "")
            BookingRequest.preisRechner();
        });
        $("#NrChildrenTravelling").on("change", function () {
            BookingRequest.preisRechner();
        });

        BookingRequest.preisRechner();
    }

    static priceResult: ResPriceData = null;

    static preisRechner() {
        const checkin = Zp.fromVacandoTs(getUrlParamInt("checkin"))
        const duration = getUrlParamInt("duration")
        const checkout = checkin + duration;
        const children = parseInt($("#NrChildrenTravelling").val() + "");
        const pax = getUrlParamInt("pax") + children;

        if (checkin < Zp.today() || pax < 1 || duration < 1 || duration > 28) {
            return; // ungültige, bzw. nicht mehr gültige Daten
        }

        const r: ReqPriceData = {
            check_in: Zp.iso(checkin),
            check_out: Zp.iso(checkout),
            pax: pax,
            children: children
        };
        BookingRequest._preisrechnerDisplay(null);
        PreisRechner.request(r, (res: ResPriceData) => {
            BookingRequest._preisrechnerDisplay(res);
        });
    }

    private static _submitButtonActive(active: boolean) {
        const submit = $("#submit");
        if (active) {
            submit.addClass("btn-primary");
            submit.removeClass("btn-warning");
            submit.removeClass("disabled");
            submit.removeAttr("disabled");
        } else {
            submit.attr("disabled", "disabled");
            submit.removeClass("btn-primary");
            submit.addClass("btn-warning");
            submit.addClass("disabled");
        }
    }

    private static _preisrechnerDisplay(p: ResPriceData) {
        BookingRequest.priceResult = p;

        // --- Buchungsbutton pauschal deaktivieren ---
        BookingRequest._submitButtonActive(false);

        if (p) {
            const ci = Zp.format(Zp.fromIso(p.req.check_in));
            const co = Zp.format(Zp.fromIso(p.req.check_out));
            $("#checkin, #checkin-xs").html(ci);
            $("#checkout, #checkout-xs").html(co);
            if (p.price) {
                const priceText = p.currency + " " + Detail.formatPrice(p.price);
                $("#price, #price-xs").html(priceText);
                // --- Buchungsbutton aktivieren ---
                BookingRequest._submitButtonActive(true);
            } else {
                $("#price, #price-xs").html("<span style='color: #e00;font-weight: bold'>" + p.txt_not_available + "</span>");
            }
        } else {
            $("#checkin, #checkin-xs").html("---");
            $("#checkout, #checkout-xs").html("---");
            $("#price, #price-xs").html("---");
        }

        //     jheader.html("<span><strong>" + p.currency + "</strong> <strong class=\"brand-primary-1-text\">" + Detail.formatPrice(p.price / p.nights) + "</strong></span> " + p.txt_per_night);
        //     $("#price-result").html(`<table class="table service-cost">
        //                                 <tbody>
        //                                     <tr>
        //                                         <td>Preis für <span>` + p.nights + ` Nächte</span></td>
        //                                         <td class="text-right">` + p.currency + ` ` + Detail.formatPrice(p.price) + `</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td>Service-Gebühr</td>
        //                                         <td class="text-right">` + p.currency + ` ` + Detail.formatPrice(0) + `</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td class="amount">` + p.txt_base_price + `</td>
        //                                         <td class="text-right amount text-nowrap">` + p.currency + ` ` + Detail.formatPrice(p.price) + `</td>
        //                                     </tr>
    }

}
